import { render, staticRenderFns } from "./PreviousOrders.vue?vue&type=template&id=6a471a48&"
import script from "./PreviousOrders.vue?vue&type=script&lang=js&"
export * from "./PreviousOrders.vue?vue&type=script&lang=js&"
import style0 from "./PreviousOrders.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports